import phoneService from "../../../services/phoneService";

export const isProfilePhoneEmpty = (phone) => phoneService.isProfilePhoneEmpty(phone);

export const getProfilePhoneError = (phone) => {
  const message = phoneService.getPhoneErrorMessage(phone);
  return message || null;
};

export const getProfilePhoneForSave = (phone) => {
  if (isProfilePhoneEmpty(phone)) {
    return null;
  }
  return phoneService.normalizePhoneForV2Api(phone);
};

export const withLineNumber = (phone) => phoneService.withLineNumber(phone);
